import { render, staticRenderFns } from "./import-remark-dialog.vue?vue&type=template&id=1266ac05&scoped=true"
import script from "./import-remark-dialog.vue?vue&type=script&lang=js"
export * from "./import-remark-dialog.vue?vue&type=script&lang=js"
import style0 from "./import-remark-dialog.vue?vue&type=style&index=0&id=1266ac05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266ac05",
  null
  
)

export default component.exports